import React, { useEffect } from 'react'
import Styles from './TileStyles.module.css';
import { Spin, Tag } from 'antd';
import { useSelector } from 'react-redux';
import CountUp from 'react-countup';

export default function Tile({ color, title, count, icon, data }) {
	const state = useSelector(state => state.cmOverview);
	const showCount = () => {
		let val = ""
		if (data === 'firstAvgRespTime') {
			// val = `${state.totalCountData.length === 0 ? 0 : state.totalCountData[data] === undefined ? 0 : parseInt(state.totalCountData[data])}m`;
			if(state.totalCountData[data] > 59)
			{
				let hours = state.totalCountData.length===0?0:state.totalCountData[data]===undefined?0:parseInt(state.totalCountData[data])/60;
				let mins = state.totalCountData.length===0?0:state.totalCountData[data]===undefined?0:parseInt(state.totalCountData[data])%60;
				val = `${Math.round(hours)}h ${mins}m`;
			}
			else{
				let mins = state.totalCountData.length===0?0:state.totalCountData[data]===undefined?0:parseInt(state.totalCountData[data])%60;
				val = `${mins}m`;
			}
		}
		if (data === 'totalViews' || data === 'totalSearched' || data === 'questionsTotalAnswered' || data === "totalSearched" || data === 'totalSubmitted' || data === 'unansweredCount' || data === 'deflectionRate' || data === 'domains') {
			val = `${state.totalCountData.length === 0 ? 0 : state.totalCountData[data] === undefined ? 0 : parseInt(state.totalCountData[data])}`;
		}
		if (data === 'activeCount') {
			// val = `Seekers: ${state.totalCountData.length === 0 ? 0 : state.totalCountData['seekerCount'] === undefined ? 0 : parseInt(state.totalCountData['seekerCount'])} Experts: ${state.totalCountData.length === 0 ? 0 : state.totalCountData['expertCount'] === undefined ? 0 : parseInt(state.totalCountData['expertCount'])}`;
			val = `Seekers: ${state.totalCountData.length === 0 ? 0 : state.totalCountData['seekerCount'] === undefined ? 0 : state.totalCountData['seekerCount'].toLocaleString()} Experts: ${state.totalCountData.length === 0 ? 0 : state.totalCountData['expertCount'] === undefined ? 0 : state.totalCountData['expertCount'].toLocaleString()}`;
		}
		if (data === 'employeeCount') {
			// val = `Employee: ${state.totalCountData.length === 0 ? 0 : state.totalCountData['employeeCount'] === undefined ? 0 : parseInt(state.totalCountData['employeeCount'])} Partner: ${state.totalCountData.length === 0 ? 0 : state.totalCountData['partnerCount'] === undefined ? 0 : parseInt(state.totalCountData['partnerCount'])}`;
			val = `Employee: ${state.totalCountData.length === 0 ? 0 : state.totalCountData['employeeCount'] === undefined ? 0 : state.totalCountData['employeeCount'].toLocaleString()} Partner: ${state.totalCountData.length === 0 ? 0 : state.totalCountData['partnerCount'] === undefined ? 0 : state.totalCountData['partnerCount'].toLocaleString()}`;
		}
		if (data === 'avgRespTime') {
			// let hours = state.totalCountData.length === 0 ? 0 : state.totalCountData[data] === undefined ? 0 : parseInt(state.totalCountData[data]) / 60;
			// let mins = state.totalCountData.length === 0 ? 0 : state.totalCountData[data] === undefined ? 0 : parseInt(state.totalCountData[data]) % 60;
			// val = `${Math.round(hours)}h ${mins}m`;
			if(parseInt(state.totalCountData[data]) > 59){
				let hours = state.totalCountData.length===0?0:state.totalCountData[data]===undefined?0:parseInt(state.totalCountData[data])/60;
				let mins = state.totalCountData.length===0?0:state.totalCountData[data]===undefined?0:parseInt(state.totalCountData[data])%60;
				val = `${Math.round(hours)}h ${mins}m`;
			}else{
				let mins = state.totalCountData.length===0?0:state.totalCountData[data]===undefined?0:parseInt(state.totalCountData[data])%60;
				val = `${mins}m`;
			}		
		}
		return val;
	}

	// First Response:${parseInt(state.totalCountData['firstAvgRespTime'])
	return (
		<>
			{data !== 'domains' &&
			<Tag color={color} style={{ display: 'flex', width: '90%', padding: '10px', borderRadius: '8px', marginTop: '5px',fontWeight:'bold' }}>
				<div style={{ fontSize: '30px' }}>
					<i className={icon}></i>
				</div>
				&nbsp;&nbsp;
				<div style={{ fontSize: '14px' }} >
				{/* <div style={{ display: 'flex' }}>{data === 'avgRespTime' && <span style={{ fontSize: '20px' }}> {state.totalCountData.length === 0 ? 0 : state.totalCountData[data] === undefined ? 0 : parseInt(state.totalCountData[data])}</span>}</div> */}
					{/* <div style={{ display: 'flex' }}>{title}&nbsp;{data === 'activeCount' && <span style={{ fontSize: '20px' }}> {state.totalCountData.length === 0 ? 0 : state.totalCountData[data] === undefined ? 0 : parseInt(state.totalCountData[data])}</span>}</div> */}
					<div style={{ display: 'flex' }}>{title}{data === 'activeCount' &&':'}&nbsp;{data === 'activeCount' && <span style={{ fontSize: '20px' }}> {state.totalCountData.length === 0 ? 0 : state.totalCountData[data] === undefined ? 0 : state.totalCountData[data].toLocaleString()}</span>}</div> 
					<div style={{ height: "10px" }}></div>
					{data === 'totalViews' || data === 'questionsTotalAnswered' || data === "totalSearched" || data === 'totalSubmitted' || data === 'deflectionRate' || data === 'domains' ? <CountUp end={showCount()} style={{ fontSize: '20px', fontWeight: 'bold' }} /> : <div style={{ fontSize: `${data === 'activeCount' || data === 'employeeCount' ? '13px' : '20px'}`, fontWeight: 'bold' }}>{showCount()}</div>}
				</div>
			</Tag>}
			{data === 'domains' && <Tag color={color} style={{display:'flex',width:'90%', padding:'10px', borderRadius:'8px', marginTop:'5px',fontWeight:'bold'}}>
        <div style={{fontSize:'30px'}}>
            <i className={icon}></i>
        </div>
        &nbsp;&nbsp;
        <div style={{fontSize:'14px'}} >
            <div style={{display:'flex',fontWeight:'bold'}}>Deflection Rate:&nbsp;<span style={{fontSize:'20px', fontWeight:'500'}}>{state.totalCountData['deflectionRate'] === undefined?0:parseInt(state.totalCountData['deflectionRate'])}%</span></div>
            <div style={{height:"10px"}}></div>
            <div style={{display:'flex',fontWeight:'bold'}}>Domains:&nbsp;<span style={{fontSize:'20px', fontWeight:'bold'}}>{state.totalCountData['deflectionRate'] === undefined?0:parseInt(state.totalCountData['domains'])}</span></div>
        </div>
    </Tag>}
		</>
	)
}
